import * as angular from 'angular';
import {IController, IQService, ITimeoutService} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {DataSet} from "vis-data";
import {BringozTimelineService} from "../../../commons/services/bringoz-timeline-service.service";

export class ItineraryTimelineCtrl implements IController {
  from: any;
  to: any;
  itinerary: any;
  tasks: any;
  relatedItineraries: any;
  relatedTasks: any;
  hiddenAgentIds: any;
  selectedItemId: any;
  highlightedItemId: any;
  canEdit: any;
  doFit: any;
  onTaskSelection: Function;
  onSelectAgent: Function;
  onToggleAgent: Function;
  onTaskHighlight: Function;
  onTaskRightClick: Function;
  onChangeItinerary: Function;


  private readonly vis: any;
  private readonly dateAndTimeConfig: any;
  private readonly timeFormat: any;
  private readonly shortDateFormat: any;
  private readonly longDateFormat: any;
  private readonly taskPurposeToColorMap: any;
  private container: any;
  private timeline: any;
  private options: any;
  private groupsDataSet: any;
  private itemsDataSet: any;
  private tableHeaderDivRef: any;
  private movedItemOriginalData: any;
  private iconsUrl: any;
  private movingItem: any;

  // Single delegated click handler for all group-row actions, attached once on
  // `this.container` in `_init`. Per-cell `addEventListener` calls inside
  // `groupTemplate` previously created N new listeners on every vis redraw —
  // now each cell only needs `data-bz-action` + `data-bz-id` attributes.
  private readonly _onContainerClick = (event: Event) => {
    const target = event.target as Element | null;
    if (!target) return;
    const actionEl = target.closest('[data-bz-action]') as HTMLElement | null;
    if (!actionEl) return;
    const action = actionEl.dataset.bzAction;
    const id = actionEl.dataset.bzId;
    if (!action || !id) return;
    this._onClicked().then(() => {
      if (action === 'select-agent') {
        this.onSelectAgent({agentId: id});
      } else if (action === 'toggle-agent') {
        this.onToggleAgent({id: id});
      }
    });
  };


  /* @ngInject */
  constructor(private $q: IQService, private $filter,
              private $timeout: ITimeoutService, private tasksConstants, private splitService: SplitService,
              private bringozTimelineService: BringozTimelineService, private moment) {
    this.vis = require('vis-timeline');
    this.dateAndTimeConfig = this.splitService.getDateAndTimeConfig();
    this.timeFormat = this.dateAndTimeConfig.time;
    this.shortDateFormat = this.dateAndTimeConfig.date;
    this.longDateFormat = this.dateAndTimeConfig.long;
    this.taskPurposeToColorMap = this.tasksConstants.purposeToColor;
    this.groupsDataSet = new DataSet()
    this.itemsDataSet = new DataSet()
  }

  $onInit() {
    this.iconsUrl = {
      relation: 'assets/images/icons/v2/relation.svg',
      eyeOn: 'assets/images/icons/v2/show.svg',
      eyeOff: 'assets/images/icons/v2/hide.svg',
      linkTo: 'assets/images/icons/v2/link-to.svg',
      agent: {
        Driver: 'assets/images/icons/agents/driver_flat.svg',
        ServiceAgent: 'assets/images/icons/agents/serviceagent_flat.svg'
      }
    }

    // Check permissions to update roues
    if (_.isUndefined(this.canEdit)) {
      this.canEdit = false;
    }

    // Create Main Container
    this.container = document.getElementById('timeline');

    // Set Options
    this.options = {
      // option groupOrder can be a property name or a sort function
      // the sort function must compare two groups and return a value
      //     > 0 when a > b
      //     < 0 when a < b
      //       0 when a == b
      groupOrder: (a, b) => {
        return a.value - b.value;
      },
      groupOrderSwap: (groupDragged, groupToSwap, groups) => {
        const value = groupDragged.value;
        groupDragged.value = groupToSwap.value;
        groupToSwap.value = value;
      },
      groupTemplate: (group) => {

        if (!group) {
          return null;
        }

        const container = document.createElement('div');
        container.classList.add("agent-details-container");

        const imageContainer = document.createElement('div');
        imageContainer.classList.add("image-container");

        if (group.imageUrl) {
          const agentImage = document.createElement("IMG");
          agentImage.setAttribute("src", group.imageUrl);
          imageContainer.insertAdjacentElement('beforeend', agentImage);
        } else {
          const imageDiv = document.createElement('div');
          imageDiv.classList.add("agent-image-initials-div");
          const imageSpan = document.createElement("span");
          imageSpan.innerText = group.nameInitials;
          imageDiv.insertAdjacentElement('beforeend', imageSpan);
          imageContainer.insertAdjacentElement('beforeend', imageDiv);
        }

        const infoDiv = document.createElement('div');
        infoDiv.classList.add("agent-info-container");

        const name = document.createElement('a');
        name.classList.add("br-link-1", "br-body-2");
        name.innerText = group.name;
        if (group.id) {
          name.dataset.bzAction = 'select-agent';
          name.dataset.bzId = String(group.id);
        }
        infoDiv.insertAdjacentElement('beforeend', name);

        const agentTypeDiv = document.createElement('div');
        agentTypeDiv.classList.add("agent-type-div");

        // var agentIcon = document.createElement('IMG');
        // agentIcon.setAttribute("src", iconsUrl.agent[group.agentType]);
        // agentIcon.classList.add('agent-icon');

        const type = document.createElement('span');
        type.classList.add("agent-type", 'br-caption-1');
        type.textContent = this.$filter('translate')(group.agentType);

        // agentTypeDiv.insertAdjacentElement('beforeend',agentIcon);
        agentTypeDiv.insertAdjacentElement('beforeend', type);
        infoDiv.insertAdjacentElement('beforeend', agentTypeDiv);

        const actionContainer = document.createElement('div');
        actionContainer.classList.add("container-center-center");

        const eyeButton = this._createEyeButton(group.id, !_.includes(this.hiddenAgentIds, group.id));
        actionContainer.insertAdjacentElement('beforeend', eyeButton);
        container.insertAdjacentElement('beforeend', actionContainer);

        if (group.isLinked) {
          const linkedIconContainer = document.createElement('div');
          linkedIconContainer.classList.add("container-center-center");

          const linkedIcon = document.createElement('IMG');
          linkedIcon.setAttribute("src", this.iconsUrl.relation);
          linkedIcon.classList.add("linked-icon");
          linkedIconContainer.insertAdjacentElement('beforeend', linkedIcon);
          container.insertAdjacentElement('beforeend', linkedIconContainer);
        }

        container.insertAdjacentElement('beforeend', imageContainer);
        container.insertAdjacentElement('beforeend', infoDiv);

        return container;
      },
      // onMoving: (item, callback) => {
      //   if (item.stopId) {
      //     if (_.isUndefined(this.movedItemOriginalData)) {
      //       const orderedItems = this.timeline.components[3].groups[item.group].orderedItems.byStart;
      //       this.movedItemOriginalData = {
      //         group: item.group,
      //         index: _.findIndex(orderedItems, (orderedItem: any) => {
      //           return orderedItem.data.activityId === item.activityId;
      //         })
      //       }
      //     }
      //     callback(item); // updating the item
      //   }
      //   else {
      //     callback(null); // cancel updating the item
      //   }
      // },
      // onMove: (item, callback) => {
      //   const fromRouteId = item.routeId;
      //   const toRouteId = item.group;
      //
      //   callback(item);
      //   const canMove = this._canItemMove(item);
      //
      //   if (!canMove) {
      //     callback(null);
      //     return;
      //   }
      //
      //   const groupsMap = this.timeline.components[3].groups;
      //   const isBetweenRoutes = fromRouteId !== toRouteId;
      //
      //   this.movedItemOriginalData = undefined;
      //
      //   this.onMoveItem(
      //     {
      //       jobIds: item.jobIds,
      //       fromRouteId: fromRouteId,
      //       toRouteId: toRouteId,
      //       fromOrderedIds: _.chain(
      //         groupsMap[fromRouteId].orderedItems.byStart)
      //         .filter(function (item) {
      //           return _.isEqual(item.data.activityType, 'STOP');
      //         })
      //         .map(function (filteredItem) {
      //           return filteredItem.data.stopId;
      //         })
      //         .value(),
      //       toOrderedIds: isBetweenRoutes ?
      //         _.chain(
      //           groupsMap[toRouteId].orderedItems.byStart)
      //           .filter(function (item) {
      //             return _.isEqual(item.data.activityType,
      //               'STOP');
      //           })
      //           .map(function (filteredItem) {
      //             return filteredItem.data.stopId;
      //           })
      //           .value() : undefined
      //     }
      //   );
      //   ctrl.movingItem = undefined;
      // },
      snap: (date, scale, step) => {
        var minute = 60 * 1000;
        return Math.round(date / minute) * minute;
      },
      // onAdd: (data, callback) => {
      //   if (!data.items || !data.items.length) {
      //     callback(null);
      //     return;
      //   }
      //
      //   const canAdd = this._canLeftoversAddToRoute(data.items, data.group);
      //
      //   if (!canAdd) {
      //     callback(null);
      //     return;
      //   }
      //
      //   const route = _.find(this.routes, (r) => {
      //     return r.id ===  data.group;
      //   });
      //
      //   let index;
      //   let order = [];
      //
      //   _.forEach(route.activities, (a, i) => {
      //     if (a.eta < data.start.valueOf()) {
      //       index = i + 1;
      //     }
      //     if (_.isEqual(a.type, 'STOP')) {
      //       order.push(a.stopId);
      //     }
      //     if (_.isEqual(a.type, 'GROUP')) {
      //       order = order.concat(a.stopIds);
      //     }
      //   });
      //   if (index) {
      //     let stopIds = [];
      //     let jobIds = [];
      //     _.forEach(data.items, (i) => {
      //       stopIds = stopIds.concat(i.stopIds);
      //       jobIds = jobIds.concat(i.jobIds)
      //     });
      //
      //     _.forEach(stopIds, (id, i) => {
      //       order.splice(index + i, 0, id);
      //     });
      //     this.onAddStopsToRoute({routeId: data.group, jobIds: jobIds, order: order})
      //   }
      //   callback(null);
      // },
      orientation: 'top',
      // editable: true,
      // selectable: true,
      format: {
        minorLabels: {
          minute: this.timeFormat,
          hour: this.timeFormat,
          weekday: this.longDateFormat,
          day: this.shortDateFormat
        }
      },
      xss: {
        disabled: true,
        // filterOptions: {
        //   whiteList: { p: ['class', 'data-from-template'], div: 'class' },
        // },
      },
      editable: {
        add: this.canEdit,                // add new items by double tapping
        updateTime: this.canEdit,        // drag items horizontally
        updateGroup: false,             // drag items from one group to another
        remove: false,                 // delete an item by tapping the delete button top right
        overrideItems: true           // allow these options to override item.editable
      },
      groupEditable: this.canEdit,
      verticalScroll: true,
      zoomKey: 'ctrlKey',
      width: '100%',
      height: '100%',
      margin: {
        item: 5
      },
      stack: false,
      showTooltips: true,
      tooltip: {
        followMouse: true
      },
      start: this.from ? this.moment(this.from).subtract(2, 'day') : this.moment().startOf('month'),
      end: this.to ? this.moment(this.to).add(2, 'day') : this.moment().endOf('month'),
      // min: ctrl.from ? moment(ctrl.from).subtract(2, 'day') : moment().startOf('month'),
      // max: ctrl.to ? moment(ctrl.to).add(2, 'day') : moment().endOf('month'),
      zoomMin: 1080000 // Zoom In Max 5 Mins
      // zoomMax: 18800000 // Zoom Out Max 1 Hour,
    };

    // Set Timeline
    this.timeline = new this.vis.Timeline(this.container, [], this.options);

    // Single delegated click handler — replaces per-cell addEventListener calls
    // inside groupTemplate so listener count stays O(1) regardless of vis redraws.
    this.container.addEventListener('click', this._onContainerClick);

    // Set Table Header Element
    const topElementRef = this.timeline.body.dom.top;
    topElementRef.style = 'left: 0px';

    this.tableHeaderDivRef = document.createElement("div");
    this.tableHeaderDivRef.classList.add("table-header-container");
    topElementRef.before(this.tableHeaderDivRef);

    // Set Timeline
    this.timeline.setGroups(this.groupsDataSet);
    this.timeline.setItems(this.itemsDataSet);

    // Init Groups/Items Data
    this._initTimelineData(this.itinerary, this.tasks, this.relatedItineraries, this.relatedTasks);

    this._initTimelineEventListeners();
  }

  $onChanges(changes) {
    if (changes.itinerary && !changes.itinerary.isFirstChange()) {
      const currentAgentId = _.get(changes, 'itinerary.currentValue.agent.id', 1);
      const previousAgentId = _.get(changes, 'itinerary.previousValue.agent.id', 0);


      if (currentAgentId !== previousAgentId) {
        this._reinitTimeline();
      }
    }

    if (changes.relatedItineraries && !changes.relatedItineraries.isFirstChange()) {
      this._reinitTimeline();
    }

    if (changes.tasks && !changes.tasks.isFirstChange()) {
      const currentTasks = changes.tasks.currentValue,
        previousTasks = changes.tasks.previousValue,
        doFit = _.isUndefined(previousTasks);

      // _reinitTimeline(true);
      this.itemsDataSet.clear();
      this._setItems(this.tasks, this.relatedTasks);

      if (doFit) {
        this.onFit();
      }
    }

    if (changes.relatedTasks && !changes.relatedTasks.isFirstChange()) {
      // _reinitTimeline(true);
      this.itemsDataSet.clear();
      this._setItems(this.tasks, this.relatedTasks);
      this.onFit();

    }

    // if (changes.selectedItemId && !changes.selectedItemId.isFirstChange()) {
    //     var selectedTask = _getTimelineTaskById(ctrl.selectedItemId);
    //     if (selectedTask) {
    //         timeline.setSelection(selectedTask.id);
    //     }
    // }

    // highlightedItemId

    if (changes.from && !changes.from.isFirstChange() ||
      changes.to && !changes.to.isFirstChange()) {

      this.options.min = this.moment(this.from).subtract(1, 'hour');
      this.options.max = this.moment(this.to).add(1, 'hour');
      this.timeline.setOptions(this.options);
    }

    if (changes.hiddenAgentIds && !changes.hiddenAgentIds.isFirstChange()) {
      const eyeButtons = document.getElementsByClassName("eye-button");
      _.forEach(eyeButtons, (b) => {
        const isEnabled = !_.includes(this.hiddenAgentIds, b.id);

        if (!isEnabled) {
          b.classList.add('disabled');
        } else {
          b.classList.remove('disabled');
        }
      });
    }

    if (changes.doFit && !changes.doFit.isFirstChange()) {
      if (this.doFit) {
        this.onFit();
      }
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onFit() {
    // _onClicked().then(function() {
    //     timeline.fit();
    // });
    this.$timeout(0).then(() => {
      this.timeline.fit();
    })
    // timeline.fit();
  }

  onZoom(isZoomIn) {
    isZoomIn ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
  }

  // ******************************
  //        Private methods
  // ******************************

  private _getGroupData(agent) {
    return {
      id: agent.id,
      name: this.$filter('userName')(agent.user),
      nameInitials: this.$filter('userInitials')(agent.user),
      imageUrl: agent.user.avatarUrl,
      agentType: agent.agentType,
      isLinked: !_.isEqual(agent.id, _.get(this.itinerary, 'agent.id'))
    };
  }

  private _getItemsData(tasks, isRelatedAgentTasks?) {
    return _.map(tasks, (task, index) => {
      const isBundle = _.isEqual(task.taskType, 'BundledStopover');
      const isInternal = _.isEqual(task.taskType, 'Internal');
      const isCompleted = _.isEqual(task.status, 'CourierDeparted');
      const isCanceled = _.isEqual(task.status, 'Canceled');
      const defaultServiceTime = 300000;
      const taskServiceTime = _.get(task, 'analysis.serviceTime') > defaultServiceTime ?
        _.get(task, 'analysis.serviceTime') :
        defaultServiceTime;
      const taskEta = isCompleted ? _.get(task, 'agentDepartureTime') : (isCanceled ? _.get(task, 'agentArrivalTime') : _.get(task, 'analysis.eta'));
      // var taskEtd = isRelatedAgentTasks ?
      //     (taskEta + taskServiceTime) :
      //     _.get(task, 'analysis.etd', taskEta + taskServiceTime);
      // var taskEtd = isCompleted ? _.get(task, 'agentArrivalTime') : taskEta + taskServiceTime;
      const taskEtd = isInternal ? (taskEta + taskServiceTime) : _.get(task, 'analysis.etd') || (taskEta + taskServiceTime);
      const purpose = task.taskSpec.purpose;
      const taskEtaWindow = this.$filter('timeWindow')({notBefore: taskEta, notAfter: taskEtd});
      const color = this.taskPurposeToColorMap[purpose];
      const relations = _.get(task, 'relations', []);
      let taskClass = isBundle ? 'bundle' : 'task';
      const isEnabled = !isRelatedAgentTasks || (task.relations && _.find(task.relations, (r) => {
        return _.get(r, 'details.agentId') === _.get(this.itinerary, 'agent.id');
      }));
      taskClass += (!isEnabled ? ' disabled' : '')

      return {
        id: task.id,
        serviceId: task.bundleServiceIdList ? task.bundleServiceIdList[0] : task.serviceId,
        start: this.moment(taskEta),
        end: this.moment(taskEtd),
        group: task.agentId,
        bundleTasks: _.get(task, 'bundledTaskList', []), // For Bundle Only
        purpose: purpose,
        // relatedRoutes: relatedRoutes || [],
        // relatedStops: relatedStops || [],
        // warnings: warnings || [],
        point: 'box',
        title: this.bringozTimelineService.getItineraryTaskTimelineItemTooltip(task, taskEtaWindow, relations),
        content: !isBundle ?
          this.bringozTimelineService.getTaskTimelineItemContent(task, relations, true) :
          this.bringozTimelineService.getBundleTaskTimelineItemContent(task, relations, true),
        style: 'background-color: ' + color + '; color: white',
        // style: isStop ? 'color: '+ color : 'background-color: ' + color,
        className: taskClass
        // style: 'border-color: ' + (route.color || 'black') + ';' + 'background-color: white;'
      }
    })
  }

  private _clearTimelineData() {
    this.groupsDataSet.clear();
    this.itemsDataSet.clear();
  }

  private _initTimelineData(itinerary, tasks, relatedItineraries, relatedTasks) {
    this._setGroups(itinerary, relatedItineraries);
    this._setItems(tasks, relatedTasks);
  }

  private _setGroups(itinerary, relatedItineraries) {
    const groups = [];

    if (itinerary && itinerary.agent) {
      groups.push(this._getGroupData(itinerary.agent))
    }

    _.forEach(relatedItineraries, (relatedItinerary) => {
      groups.push(this._getGroupData(relatedItinerary.agent))
    })

    this.groupsDataSet.add(_.uniqBy(groups, 'id'));
  }

  private _setItems(tasks, relatedTasks) {

    if (!tasks) {
      tasks = [];
    }

    if (!relatedTasks) {
      relatedTasks = [];
    }

    let items = [];
    let backgroundItems = [];

    //TODO add items background for the tasks
    items = items.concat(this._getItemsData(tasks));

    // backgroundItems.push({
    //     id: agent.id,
    //     start: moment(route.activities[0].eta),
    //     end: moment(route.activities[route.activities.length - 1].eta),
    //     group: route.id,
    //     type: 'background',
    //     style: 'background-color: ' + color
    // });

    items = items.concat(this._getItemsData(relatedTasks, true));

    items = items.concat(backgroundItems);
    this.itemsDataSet.add(_.uniqBy(items, 'id'));
  }

  private _onClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  private _getTimelineGroupById(id) {

    if (!id) {
      return undefined;
    }

    const selectedGroup = this.groupsDataSet.get({
      filter: (group) => {
        return group.id === id;
      }
    });
    return this.itemsDataSet.get(selectedGroup[0] ? selectedGroup[0].id : undefined)
  }

  private _getTimelineTaskById(id) {

    if (!id) {
      return undefined;
    }

    var selectedItem = this.itemsDataSet.get({
      filter: (item) => {
        return item.id === id;
      }
    });
    return this.itemsDataSet.get(selectedItem[0] ? selectedItem[0].id : undefined)
  }

  // private _canItemMove(item) {
  //
  //   var movingToRoute = _.find(this.routes, (r) => {
  //     return r.id === item.group;
  //   })
  //
  //   if (!item.stopId || (item.activityType === 'GROUP' && !item.stopIds.length)) {
  //     return false;
  //   }
  //
  //   if (movingToRoute) {
  //     var resourceSkills = _.get(movingToRoute, 'resource.allocationSkills', []);
  //     var itemSkill = item.purpose === 'Operation' ? 'Merchandise' : 'Delivery';
  //     if (!_.includes(resourceSkills, itemSkill)) {
  //       var stopType = $filter('translate')('SKILLS.' + itemSkill);
  //       var routeType = $filter('translate')('SKILLS.' + resourceSkills[0]);
  //       PlanningAlerts.stopTypeToRouteRejectionInfo(stopType, routeType);
  //       return false;
  //     }
  //   }
  //
  //   var orderedItems = timeline.components[3].groups[item.group].orderedItems.byStart;
  //
  //   var itemPurpose = item.purpose;
  //   var itemIndex = _.findIndex(orderedItems, function (orderedItem) {
  //     return orderedItem.data.activityId === item.activityId;
  //   });
  //
  //
  //   if (_.isEqual(movedItemOriginalData.group, item.group) &&
  //     _.isEqual(movedItemOriginalData.index, itemIndex)) {
  //     return false;
  //   }
  //
  //
  //   var parallelIndex = _.findIndex(orderedItems, function (task) {
  //     return task.parentId === item.parentId;
  //   });
  //   if (!parallelIndex) {
  //     return true;
  //   } else {
  //     return itemPurpose === 'Pickup' ? (itemIndex < parallelIndex) : (parallelIndex < itemIndex);
  //   }
  // }

  // private _canLeftoversAddToRoute(leftovers, toRouteId) {
  //   var route = _.find(ctrl.routes, function (r) {
  //     return r.id === toRouteId;
  //   })
  //   var canAddBulk = true;
  //   _.forEach(leftovers, function (l) {
  //     var resourceSkills = _.get(route, 'resource.allocationSkills', []);
  //     var leftoverSkill = l.jobType === 'Operation' ? 'Merchandise' : 'Delivery';
  //     if (!_.includes(resourceSkills, leftoverSkill)) {
  //       var stopType = $filter('translate')('SKILLS.' + leftoverSkill);
  //       var routeType = $filter('translate')('SKILLS.' + resourceSkills[0]);
  //       PlanningAlerts.stopTypeToRouteRejectionInfo(stopType, routeType);
  //       canAddBulk = false;
  //       return false;
  //     }
  //   })
  //   return canAddBulk;
  // }

  private _reinitTimeline(doFit?) {
    // Clear Groups/Items Data
    this._clearTimelineData();

    // Init Groups/Items Data
    this._initTimelineData(this.itinerary, this.tasks, this.relatedItineraries, this.relatedTasks);

    if (doFit) {
      this.$timeout(0).then(() => {
        this.onFit();
      })
    }
  }

  private _initTimelineEventListeners() {

    /////////////////////
    // Timeline Events //a
    /////////////////////

    // Hover
    this.timeline.on('mouseOver', (props) => {
      if (props.item) {
        this._onClicked().then(() => {
          this.onTaskHighlight({task: this._getTimelineTaskById(props.item), $event: props.event});
        });
      } else if (this.highlightedItemId) {
        this._onClicked().then(() => {
          this.onTaskHighlight({task: undefined, $event: props.event});
        });
      }
    });

    // On Item Click
    this.timeline.on('select', (properties) => {
      this._onClicked().then(() => {
        const selectedTask = this._getTimelineTaskById(properties.items[0]);
        this.onTaskSelection({serviceId: _.get(selectedTask, 'serviceId'), taskId: _.get(selectedTask, 'id')});
      });
    });

    // On Timeline Click
    // timeline.on('click', function (properties) {
    //     _onClicked().then(function() {
    //         if (ctrl.inspectedStopIds && ctrl.inspectedStopIds.length && !properties.item) {
    //             ctrl.onInspectedStopIdsChange({ids: []});
    //         }
    //     });
    // });

    // // Right Click
    // this.timeline.on('contextmenu', (props) => {
    //   if (props.item) {
    //     const selectedTask = this._getTimelineTaskById(props.item);
    //     if (selectedTask && this.canEdit) {
    //       var activityType = this.selectedActivity.activityType;
    //       if (activityType === 'STOP' || activityType === 'GROUP') {
    //
    //         var stopIds = activityType === 'STOP' ?
    //           [_.get(this.selectedActivity, 'stopId')] :
    //           _.get(this.selectedActivity, 'stopIds', []);
    //
    //         _onClicked().then(function () {
    //           ctrl.onActivityRightClick({
    //             routeId: _.get(selectedActivity, 'routeId'),
    //             jobIds: selectedActivity.jobIds,
    //             stopIds: stopIds,
    //             relations: selectedActivity.relatedStops,
    //             $event: props.event
    //           })
    //         });
    //       }
    //     }
    //   }
    //   props.event.preventDefault();
    // });

  }

  private _createEyeButton(id, isEnabled) {
    const eyeButton: any = document.createElement('IMG');
    eyeButton.setAttribute("src", this.iconsUrl.eyeOn);
    // eyeButton.setAttribute("src", isEnabled ? iconsUrl.eyeOn: iconsUrl.eyeOff);
    eyeButton.classList.add('bringoz-icon-small', 'action-button', 'eye-button');
    if (!isEnabled) {
      eyeButton.classList.add('disabled');
    }
    eyeButton.id = id;
    eyeButton.enabled = isEnabled;
    if (id) {
      eyeButton.dataset.bzAction = 'toggle-agent';
      eyeButton.dataset.bzId = String(id);
    }
    return eyeButton;
  }

  private _createAgentLinkButton(agentId, onClick) {
    const agentLinkIcon = document.createElement('IMG');
    agentLinkIcon.setAttribute("src", this.iconsUrl.linkTo);
    agentLinkIcon.classList.add('action-button');
    agentLinkIcon.id = agentId;
    // agentLinkButton.classList.add("md-icon-button", "eye-button", "table-button");

    // Button Event Listener
    agentLinkIcon.addEventListener("click", () => {
      this._onClicked().then(() => {
        onClick();
      });
    }, {passive: true});

    return agentLinkIcon;
  }

  $onDestroy() {
    if (this.container) {
      this.container.removeEventListener('click', this._onContainerClick);
      this.container = null;
    }
    if (this.timeline) {
      this.timeline.destroy();
      this.timeline = null;
    }
    if (this.itemsDataSet) {
      this.itemsDataSet.clear();
      this.itemsDataSet = null;
    }
    if (this.groupsDataSet) {
      this.groupsDataSet.clear();
      this.groupsDataSet = null;
    }
  }


}

angular
  .module('bringoz.admin.itineraries')
  .component('itineraryTimeline', {
    bindings: {
      from: '<',
      to: '<',
      itinerary: '<',
      tasks: '<',
      relatedItineraries: '<?',
      relatedTasks: '<?',
      hiddenAgentIds: '<',
      selectedItemId: '<',
      highlightedItemId: '<',
      canEdit: '<',
      doFit: '<?',
      onTaskSelection: '&',
      onSelectAgent: '&',
      onToggleAgent: '&',
      onTaskHighlight: '&',
      onTaskRightClick: '&',
      onChangeItinerary: '&',
    },
    template: require('./itinerary-timeline.html').default,
    controller: ItineraryTimelineCtrl
  });
